import { render, staticRenderFns } from "./MovieDetail.vue?vue&type=template&id=4f1209a0&scoped=true&"
import script from "./MovieDetail.vue?vue&type=script&lang=js&"
export * from "./MovieDetail.vue?vue&type=script&lang=js&"
import style0 from "./MovieDetail.vue?vue&type=style&index=0&id=4f1209a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1209a0",
  null
  
)

export default component.exports